import styled from "styled-components";

const Player = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .time-control {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-evenly;
    input {
      width: 100%;
      padding: 1rem 0rem;
    }
  }

  .play-control {
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    width: 30%;
    align-items: center;
  }
`;


export { Player };
